import React from 'react';
import ExpandedComponent from "../../microComponents/tablePages/ExpandedComponent";
import PalletStatus from "../../microComponents/elements/PalletStatus";

const ExpandedPalletStatus = ({item}) => {
    return (
        <ExpandedComponent items={[
            {title: 'توضیحات', value: item.description},
            {title: 'واحد سنجش', value: item.unitMeasurement},
            {title: 'نوع', value: item.type},
            {title: 'مسئول پرینت', value: item.printBy},
            {title: 'تعداد تحویل شده', value: item.deliverNumberPerPack},
            {title: 'تعداد امحایی', value: item.numberOfDestroyed},
            {title: 'ثبت کننده', value: item.seriCreateBy},

            {title: 'محصول', value: item.product,class:'2xs:hidden'},
            {title: 'برند', value: item.brand,class:'sm:hidden'},
            {title: 'خط تولید', value: item.productLine,class:'md:hidden'},
            {title: 'وضعیت', value:<PalletStatus data={item}/> ,class:'md:hidden'},
            {title: 'واحد', value: item.branch,class:'2md:hidden'},
            {title: 'موقعیت', value: item.location,class:'lg:hidden'},
            {title: 'تعداد در پالت', value: item.numberPerPallet,class:'lg:hidden'},
            {title: 'ق.ت', value: item.manufacturerPriceRials,class:'lg:hidden'},
            {title: 'ق.م', value: item.consumerPriceRials,class:'lg:hidden'},
            {title: ' تاریخ تولید', value: item.dateOfManufacture,class:'lg:hidden'},
            {title: ' تاریخ انقضا', value: item.expireDate,class:'lg:hidden'},
            {title: 'بچ', value: item.batchNumber,class:'lg:hidden'},
            {title: 'QC', value: item.qcStatus,class:'lg:hidden'},
            {title: 'کارشناس QC', value: item.qualityControlSupervisor,class:'lg:hidden'},
            {title: 'سرپرست تولید', value: item.seriCreateBy,class:'lg:hidden'},
            {title: 'شماره حواله', value: item.orderCode,class:'lg:hidden'},
            {title: 'بارگیری', value: item.allowLoadId,class:'lg:hidden'},
        ]}/>
    );
};

export default ExpandedPalletStatus;